<template>
	<div class="a-flex-rfsfs a-ptb-12">
		<div class="s-search-label a-flex-rfec a-mt-8" style="width: 82px" v-show="label">
			<span class="a-c-red a-fs-14" v-if="notnull">*</span>
			<div>{{ label }}</div>
		</div>

		<div class="a-ml-10" >
            <!-- 粘贴上传提示（启用时显示） -->
            <div v-if="enablePaste" class="paste-tip a-mb-8">
                <el-tag type="info" size="small">
                    <i class="el-icon-document-copy"></i>
                    支持 Ctrl+V / Command+V 粘贴图片上传
                </el-tag>
            </div>
            <el-upload :drag='drag' :action="url" :headers="headers" :data="data" :on-preview="handlePreview"
                :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed"
                :file-list="fileList" name="file" :on-change="handleChange">
                <el-button style="border: 1px solid #dadde0; border-radius: 4px;" icon="el-icon-upload2" v-if="!drag">{{ enablePaste ? '上传或粘贴文件' : '上传文件' }}</el-button>
                <div v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                        <br v-if="enablePaste">
                        <small v-if="enablePaste" style="color: #909399;">支持 Ctrl+V 粘贴</small>
                    </div>
                </div>
                <!-- <slot name="tip">
                    <div class="el-upload__tip a-mt-8 a-c-999 a-fs-14">
                        支持扩展名：.rar .zip .doc .docx .pdf .jpg...
                    </div>
                </slot> -->
            </el-upload>
            <div class="el-upload__tip a-c-999 a-fs-14 a-flex-cfsfs">
                支持：{{ acceptStr }}格式
                <div>
                    <span v-if="drag">支持拖拽上传</span>
                    <span v-if="enablePaste">，或粘贴板图片</span>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import Utils from '@/utils';
export default {
	props: {
		label: {
			type: String,
		},
		value: {
			required: false,
			default: "",
		},
		notnull: {
			type: Boolean,
			default: false,
			required: false,
		},
		/**
		 * 是否为较长的输入框
		 */
		large: {
			type: Boolean,
			required: false,
			default: false,
		},
        drag: {
            default: true,
            type: Boolean
        },
        acceptArr: {
			type: Array,
			default: () => [".png", ".jpg", ".jpeg", ".pdf"],
		},
        // 新增：是否启用粘贴上传
        enablePaste: {
            type: Boolean,
            default: true
        },
        // 新增：粘贴上传的自定义提示文案
        pasteHint: {
            type: String,
            default: ''
        }
	},
	data() {
		return {
			url: this.$Config.axiosBaseUrl + this.$Config.apiUrl.uploadFile,
			headers: {
				token: Utils.getToken(),
				appId: this.$Config.appId,
			},
			data: {
				key: "company/upload",
			},
			fileList: [],
			iswatch: true,
		};
	},
    computed: {
        acceptStr() {
			return this.acceptArr.join("，");
		},
    },
	watch: {
		value: {
			handler(val) {
				if (val != "") {
					if (this.iswatch) {
						if (typeof val == "string") {
							let names = val.split("/");
							let showName = names[names.length - 1];
							this.fileList.push({
								name: val,
								// name: showName
							});
						}
						this.iswatch = false;
					}
				}
			},
		},
	},
	mounted() {
		// this.fileList.push({"name":"aaa.pj"});
		// this.$emit('input', this.fileList)
        // 启用粘贴功能时，绑定粘贴事件
        if (this.enablePaste) {
            this.bindPasteEvent();
        }
	},
    beforeDestroy() {
        // 移除粘贴事件监听
        if (this.enablePaste) {
            this.unbindPasteEvent();
        }
    },
	methods: {
        // 绑定粘贴事件
        bindPasteEvent() {
            document.addEventListener('paste', this.handlePaste);
        },
        
        // 移除粘贴事件
        unbindPasteEvent() {
            document.removeEventListener('paste', this.handlePaste);
        },
        // 处理粘贴事件
        handlePaste(e) {
            // 检查是否超出限制
            if (this.fileList.length >= this.limit) {
                this.$message.warning(`最多只能上传 ${this.limit} 个文件`);
                return;
            }
            
            const items = e.clipboardData && e.clipboardData.items;
            if (!items) return;
            
            let hasImage = false;
            
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                
                // 检查是否是图片类型
                if (item.type.indexOf('image') !== -1) {
                    hasImage = true;
                    const blob = item.getAsFile();
                    
                    if (blob) {
                        // 生成文件名
                        const timestamp = new Date().getTime();
                        const ext = blob.type.split('/')[1] || 'png';
                        const filename = `paste_${timestamp}.${ext}`;
                        
                        // 创建 File 对象
                        const file = new File([blob], filename, { type: blob.type });
                        
                        // 验证文件类型
                        if (!this.validateFileType(file)) {
                            this.$message.error(`文件格式不支持，请上传 ${this.acceptStr} 格式`);
                            continue;
                        }
                        
                        // 上传到服务器
                        this.uploadPastedFile(file);
                    }
                }
            }
            
            if (hasImage) {
                // 阻止默认粘贴行为
                e.preventDefault();
            }
        },
        
        // 验证文件类型
        validateFileType(file) {
            const ext = '.' + file.name.split('.').pop().toLowerCase();
            return this.acceptArr.some(accept => 
                ext === accept.toLowerCase() || 
                file.type.includes(accept.replace('.', ''))
            );
        },
        
        // 上传粘贴的文件
        uploadPastedFile(file) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('key', this.data.key || 'company/upload');
            
            // 显示上传中
            // const loading = this.$loading({
            //     lock: true,
            //     text: '粘贴上传中...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            
            // 使用 axios 或 fetch 上传
           this.$Axios._post({
                url: this.url,
                params: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': Utils.getToken(),
                    'appId': this.$Config.appId
                }
            }).then(res => {
                // 上传成功，添加到列表
                const newFile = {
                    name: file.name,
                    url: res.data,
                    status: 'success'
                };
                
                this.fileList.push(newFile);
                this.$emit("input", this.fileList.map(item => item.url));
            }).catch(err => {
                console.error('粘贴上传失败:', err);
                this.$message.error('上传失败，请重试');
            });
        },
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning(
				`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
				} 个文件`
			);
		},
		beforeRemove(file, fileList) {
			let that = this;
			return this.$confirm(`确定移除 ${file.name}？`, {
				callback: (action) => {
					if (action == "confirm") {
						that.$emit("input", "");
						that.fileList.splice(0, 1);
					}
				},
			});
		},
		handleChange(file, fileList) {
			this.iswatch = false;
			if (file.response) {
				this.$emit("input", file.response.data);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload-dragger{
    width: 240px !important;
    height: 120px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-upload{
        font-size: 50px;
        margin: 0 auto !important;
    }
}
</style>
